import type { Theme, SxProps, Breakpoint } from '@mui/material/styles';

import { varAlpha, mergeClasses } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import { NavSectionHorizontal as NavSectionHorizontalBase } from 'src/components/nav-section';

import { layoutClasses } from '../core/classes';

// ----------------------------------------------------------------------

// NavSectionHorizontal 은 아직 JS 라 props 가 전부 필수로 추론된다 — 실제 계약(전부 선택)으로 좁혀 쓴다 (로직 무변)
const NavSectionHorizontal = NavSectionHorizontalBase as unknown as React.ComponentType<
  {
    data?: unknown;
    checkPermissions?: (allowedRoles?: any) => boolean;
  } & Record<string, unknown>
>;

type NavHorizontalProps = {
  sx?: SxProps<Theme>;
  data?: unknown;
  className?: string;
  checkPermissions?: (allowedRoles?: any) => boolean;
  layoutQuery?: Breakpoint;
} & Record<string, unknown>;

export function NavHorizontal({
  sx,
  data,
  className,
  checkPermissions,
  layoutQuery = 'md',
  ...other
}: NavHorizontalProps) {
  return (
    <Box
      className={mergeClasses([layoutClasses.nav.root, layoutClasses.nav.horizontal, className])}
      sx={[
        (theme) => ({
          width: 1,
          position: 'relative',
          flexDirection: 'column',
          display: { xs: 'none', [layoutQuery]: 'flex' },
          borderBottom: `solid 1px ${varAlpha(theme.vars.palette.grey['500Channel'], 0.08)}`,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Divider
        sx={{
          top: 0,
          left: 0,
          width: 1,
          zIndex: 9,
          position: 'absolute',
          borderStyle: 'dashed',
        }}
      />

      <Box
        sx={{
          px: 1.5,
          height: 'var(--layout-nav-horizontal-height)',
          backgroundColor: 'var(--layout-nav-horizontal-bg)',
          backdropFilter: `blur(var(--layout-header-blur))`,
          WebkitBackdropFilter: `blur(var(--layout-header-blur))`,
        }}
      >
        <NavSectionHorizontal data={data} checkPermissions={checkPermissions} {...other} />
      </Box>
    </Box>
  );
}
